<article class="x-card">
  <header class="x-card__header">
    <ng-content select="[card-header]" />
  </header>

  <ng-content />

  <footer class="x-card__footer">
    <ng-content select="[card-footer]" />
  </footer>
</article>
